export default {
  grayHeader: "特定商取引法等について",
  content: [
    {
      title: "販売会社：",
      content: "株式会社ドキドキ旅行"
    },
    {
      title: "運営統括責任者：",
      content: "則竹　慧大"
    },
    {
      title: "所在地：",
      content: "〒104-0061　東京都中央区銀座1-11-1　東京橋ビル2F"
    },
    {
      title: "お問い合わせ先：",
      inquiriesContent: {
        url: {
          title: "販売WEBサイトURL",
          content: "https://hoshinoresorts.com/jp/gift"
        },
        product: {
          title: "商品に関するお問い合わせ",
          content: "星野リゾート予約センター"
        },
        tel: {
          title: "[TEL]",
          content: "050-3134-8094",
          time: "（9:30~18:00）"
        },
        mail: {
          title: "[メール]",
          content: "info_gift@dokidokitravel.com"
        }

      }
    },
    {
      title: "商品代金：",
      commodityContent: {
        gift: {
          title: "星野リゾート宿泊ギフト券",
          content: "1枚あたり5万円"
        },
        cost: {
          title: "配送料",
          content: "1ヶ所あたり全国一律600円"
        }
      }
    },
    {
      title: "お支払い方法・期限：",
      paymentAdditions: [
        {
          a: {
            title: "銀行振込",
            tip: "※ 振込手数料はお客様負担となります。"
          },
          b: {
            title: "商品お申し込み後、弊社にてご入金を確認でき次第、商品を発送いたします。"
          }
        },
        {
          a: {
            title: "クレジットカード",
            tip: "※ 利用可能なクレジットカードはVISA/MasterCardです。"
          },
          b: {
            title: "弊社にてクレジットカードでのご入金が確認でき次第、商品を発送いたします。",
            tip: "※ ご請求日は各クレジットカード会社により異なります。"
          }
        }
      ]
    },
    {
      title: "お引渡し方法：",
      content: "お申し込み時にご記載いただきましたお届け先の住所宛に郵送（貴重品扱い）でお届けいたします。"
    },
    {
      title: "お引渡し時期：",
      content: "入金確認後、3〜5日を目途に発送いたします。（土日祝を除く）",
      tip: "※ 地域や天候、交通事情等により遅れることがあります。"
    },
    {
      title: "返品・交換について：",
      content: "商品の配送間違いを除き、購入後の返品、交換はお請けしておりません。"
    },
    {
      title: "不正利用に対する対応：",
      content: "本ギフト券の使用にあたり他人のギフト券番号を使用するなどの不正利用が発生した場合は利用権利を差し止め、既に利用予約等をしている場合には券面相当の現金による支払いを請求いたします。また、本来利用者を特定した上で本来の利用権利を有効といたします。"
    },
    {
      title: "供託義務に対する対応：",
      content: "発行した金額の内、未使用にあたる金額の半額を現金により東京法務局に供託しております。"
    }
  ],
  salesCompany: {
    title: "販売会社：",
    content: "株式会社ドキドキ旅行"
  },
  supervisor: {
    title: "運営統括責任者：",
    content: "則竹　慧大"
  },
  location: {
    title: "所在地：",
    content: "〒104-0061　東京都中央区銀座1-11-1　東京橋ビル2F"
  },
  commodity: {
    title: "商品代金：",
    gift: {
      title: "星野リゾート宿泊ギフト券",
      content: "1枚あたり5万円"
    },
    cost: {
      title: "配送料",
      content: "1ヶ所あたり全国一律600円"
    }
  },
  payment: {
    title: "お支払い方法・期限：",
    additions: [
      {
        title: "銀行振込",
        tip: "※ 振込手数料はお客様負担となります。"
      },
      {
        title: "商品お申し込み後、弊社にてご入金を確認でき次第、商品を発送いたします。"
      },
      {
        title: "クレジットカード",
        tip: "※ 利用可能なクレジットカードはVISA/MasterCardです。"
      },
      {
        title: "弊社にてクレジットカードでのご入金が確認でき次第、商品を発送いたします。",
        tip: "※ ご請求日は各クレジットカード会社により異なります。"
      }
    ]
  },
  deliveryMethod: {
    title: "お引渡し方法：",
    content: "お申し込み時にご記載いただきましたお届け先の住所宛に郵送（貴重品扱い）でお届けいたします。"
  },
  deliveryTime: {
    title: "お引渡し時期：",
    content: "入金確認後、3〜5日を目途に発送いたします。（土日祝を除く）",
    tip: "※ 地域や天候、交通事情等により遅れることがあります。"
  },
  exchange: {
    title: "返品・交換について：",
    content: "商品の配送間違いを除き、購入後の返品、交換はお請けしておりません。"
  }
};



// WEBPACK FOOTER //
// ./src/i18n/ja/specified.js